import DynamicField from "./DynamicField";

export default function QuestionRenderer({question, questionAnswers, setFieldValue, validationErrors}) {
    return <>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {question.fields.map((field) => (
                <div key={field.code}
                     className={`p-2 ${field.fullWidth ? "md:col-span-2" : ""}`}>
                    <DynamicField field={field}
                                  setFieldValue={setFieldValue}
                                  answer={questionAnswers[question.code]?.[field.code]}
                                  error={validationErrors?.[field.code]}
                                  questionAnswers = {questionAnswers}
                    />
                </div>
            ))}
        </div>
    </>
}